import { render, staticRenderFns } from "./LoanOverview.vue?vue&type=template&id=c6cf0c68"
import script from "./LoanOverview.vue?vue&type=script&lang=js"
export * from "./LoanOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports